var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',_vm._l((_vm.days),function(day,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(day.name))]),_c('td',[_vm._v("\n            "+_vm._s(day.text)+"\n        ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }